import type { RemoteFile } from "../types/files/cached/RemoteFile"
import { ResolveUrl } from "@pdfking/compatibility"
import { GuidToString, StringHash, UUID } from "@pdfking/tfunc"
import { ContentType } from "../types/files/ContentType"
import { VirtualFileType } from "../types/files/VirtualFileType"
import { PathContentType } from "./PathContentType"

export const CreateRemoteFile = async ({
  file_meta,
  guid,
  mirrors,
  type,
}: Partial<RemoteFile>): Promise<RemoteFile> => {
  const resolved = mirrors?.map(m => ResolveUrl(m).href) ?? []
  return {
    enum: VirtualFileType.REMOTE_FILE,
    file_meta: file_meta || {},
    guid:
      guid ??
      GuidToString(resolved.length > 0 ? await StringHash(resolved) : UUID()),
    mirrors: resolved,
    type: type ?? PathContentType(mirrors || []) ?? ContentType.PDF,
  }
}
